import React from 'react';
import IconButton from '@mui/material/IconButton';
import { useThemeContext } from '../../Theme/ThemeContext';
import { Brightness4, Brightness7 } from '@mui/icons-material';

const ThemeToggleButton = () => {
  const { themeMode, toggleTheme } = useThemeContext();

  return (
    <IconButton onClick={toggleTheme} color="inherit">
      {themeMode === 'light' ? <Brightness4 /> : <Brightness7 />}
    </IconButton>
  );
};

export default ThemeToggleButton;